export default __webpack_public_path__ + "static/media/Mariwasa.46c91716.JPG";